export default "__VITE_ASSET__bc701897__"